import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.state';
import { OfflineStorageService } from './offline-storage.service';
import { setLoadingSpinner } from '../store/actions/shared.action';
import { BEARER_ONLY } from '../interceptor/token.interceptor';

@Injectable({
  providedIn: 'root'
})
export class EncodingService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private store: Store<AppState>,
  ) { }

  checkDuplicateEntry(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/application/check', JSON.stringify(item), {withCredentials: true});
  }

  encodeNewApplicationEntry(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/application/store', JSON.stringify(item), {withCredentials: true});
  }

  updateApplicationEntry(master_uuid: any, item: any): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/application/${master_uuid}/update`, JSON.stringify(item), {withCredentials: true});
  }

  getQueues(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/queues/list', {withCredentials: true});
  }

  getQueuesByUrl(url): Observable<any> {
    return this.http
      .get<any>(url, {withCredentials: true});
  }

  getDemographics(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/demographic/list', {withCredentials: true});
  }

  getOtherOptions(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/forms/options/other', {withCredentials: true});
  }

  getEducationOptions(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/forms/options/education', {withCredentials: true});
  }

  getOccupationOptions(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/forms/options/occupation', {withCredentials: true});
  }

  getDocumentsOptions(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/forms/options/document', {withCredentials: true});
  }

  uploadDocument(uuid: any, item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/application/${uuid}/upload`, item, {withCredentials: true, context: new HttpContext().set(BEARER_ONLY, true) },);
  }
}
